'use strict';

angular.module('far.discipline')
    .controller('DisciplineRankController', function ($rootScope, $scope, $log, $http, $window, Rank) {
        var vm = {
            progress: true,
            submitted: false,
            model: {
                people_xerox: "0",
                values: []
            },
            title: {
                people_xerox: '',
                class: '',
                type: '',
                season: ''
            },
            url: '',
            url_params: {},
            title_array: [],
            seasonList: [],
            seasonModal: false,
            disciplineUrl: '',
            date: new Date(),
            getRank: function () {
                vm.progress = true;

                vm.title_array = [];
                vm.url_params = {
                    url: vm.disciplineUrl,
                    gender: vm.model.people_xerox,
                    season: vm.model.season
                };

                vm.title_array.push(vm.title.people_xerox);

                if (vm.title.class) {
                    vm.title_array.push(vm.title.class);
                    vm.url_params.class = vm.model.class;
                }

                if (vm.title.type) {
                    vm.title_array.push(vm.title.type);
                    vm.url_params.type = vm.model.type;
                }

                vm.seasonList.map(function (season) {
                    if (season.id == vm.model.season) {
                        vm.title_array.push(season.name + ' год');
                    }
                });

                vm.url = Routing.generate('discipline_rank_edit', vm.url_params);

                vm.model.values = [];

                vm.model = Rank.get(vm.model, function () {
                    vm.progress = false;
                });
            },
            getRankSeason: function () {
                $http.get(Routing.generate('api_discipline_get_discipline_rank_seasons'))
                    .then(function (response) {
                        response.data.forEach(function (item) {
                            if (item.name == vm.date.getFullYear() && vm.model.season == undefined) {
                                vm.model.season = item.id.toString();
                            }

                            vm.seasonList.push(item);
                        });

                        if (!vm.model.season) {
                            vm.model.season = vm.seasonList[0].id.toString();
                        }

                        vm.getRank();
                    }, function (response) {
                        $log.error(response);

                        vm.progress = false;
                    });
            },
            init: function () {
                vm.getRankSeason();
            }
        };

        return vm;
    });
